import { params } from "../context";
import Api from "./Api";

const GraphQLHelper = {
	query(query: { operationName: string, variables?: { [key: string]: string | number }}, retries?: number): Promise<any> {
		return Api.post(
			`${params.recommendation_base_url}`,
			{
				query,
			},
			retries
		);
	},
};

export default GraphQLHelper;
